import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPhoneAlt } from "@fortawesome/free-solid-svg-icons";
import { faEnvelope } from "@fortawesome/free-regular-svg-icons";

export const SiteFooter = () => {
   const appRoutes = [
        { path: "/", pageTitle: 'Startseite' },
        { path: "/about", pageTitle: 'Über uns' },
        { path: "/services", pageTitle: "Leistungen" },
        { path: "/contact", pageTitle: "Kontakt" }
    ];

    return (
        <footer className="app-footer">
            <div className="footer-top">
                <div className="footer-section">
                    <img
                        className="logo-img"
                        alt=""
                        src="/act-logo.png"
                    />
                    <div className="app-slogan">
                       Buchen Sie Ihre Wohnungsreinigung direkt bei einem zuverlässigen Reinigungsunternehmen in Berlin.
                    </div>
                </div>
                <div className="footer-section flx-col">
                    <div className="section-caption">Schnellzugriff</div>
                    {appRoutes.map((route, indx) => (
                        <a href={route.path} className="q-link" key={indx}>
                            {route.pageTitle}
                        </a>
                    ))}
                </div>
                <div className="footer-section">
                    <div className="section-caption">Kontaktieren Sie uns</div>
                    <div className="contact-unit">
                        <FontAwesomeIcon icon={faPhoneAlt} />
                        <span className="contact-data">+4917622006681</span>
                    </div>
                    <div className="contact-unit flx-rw c-al">
                        <FontAwesomeIcon icon={faEnvelope} />
                        <span className="contact-data">actreinigung@gmail.com</span>
                    </div>
                </div>
            </div>
            <div className="footer-bottom"></div>
        </footer>
    )
}